/**
 * Shared constants that both `api.js` and `authRefresh.js` need. Kept in a
 * standalone module so importing one from the other never triggers a
 * circular initialization (the "Cannot access 'API_BASE' before initialization"
 * temporal-dead-zone bug).
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "royal_lady_token";
